import './PullmanSanAndreasContact.css';

import { AppData } from '../../../../services';
import GoogleMapReact from 'google-map-react';
import KuposHelmet from '../../../common/KuposHelmet';
import PullmanBanners from '../components/PullmanBanners';
import React from 'react';
import ThemeSixOfficeSection from '../components/ThemeSixOfficeSection';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';

const AnyReactComponent = ({ img }) => (
	<div>
		<img
			style={{
				display: 'inline-block',
				width: '20px',
			}}
			alt=""
			src={img}
		/>
	</div>
);

function PullmanSanAndreasContact({ home }) {
	const operator = home.operator ? home.operator : '';

	return (
		<div className="pullman-san-andreas-contact">
			<PullmanBanners
				bgImage={getIcons('contactBanner')}
				text={'Hablemos'}
				textPosition={'center'}
			/>
			<KuposHelmet />

			<div className="main-heading">
				<h3
					className="bold-text text-center font-italic "
					style={{
						color: operator && operator.theme_color && operator.theme_color,
					}}
				>
					La unidad y compromiso de nuestra gente, es nuestra fortaleza
				</h3>
				<p className="bottom-para text-center font-italic">
					sé parte de <span className="pullman-bold-text">Pullman San Andrés</span>
				</p>
			</div>
			<div className="new-container">
				<div className="pullman-san-andreas-contact-content">
					<div className="pullman-san-andreas-contact-content-left">
						<h3 className="sub-main-heading pullman-bold-text font-italic">
							Información de contacto
						</h3>
						<div className="margin-bottom-30 font-weight-semi-bold">
							{/* <span>Av. Las Parcelas #1234, Alto Hospicio.</span>
              <br />
              <span>Región de Tarapacá.</span> */}
							<span>{operator && operator.address}</span>
						</div>

						<div className="margin-bottom-30 font-weight-semi-bold">
							<span><b>Teléfono: </b>{operator && operator.phone_number}</span>

							{/* <span>Callcenter: +56 57 2</span>
							<br />
							<span>WhatsApp: +56 9</span> */}
						</div>
						<div className="margin-bottom-30 font-weight-semi-bold">
							{/* <span>info@pullmansanandres.cl</span> */}
							<span><b>Email: </b>{operator && operator.email}</span>
						</div>

						<div className="margin-bottom-30 font-weight-semi-bold">
							<span>Redes sociales</span>
						</div>

						<div className="margin-bottom-30 font-weight-semi-bold underline">
							<span
								onClick={() => {
									window.open('https://www.instagram.com/pullmansanandres.cl/');
								}}
							>
								Instagram
							</span>
							<br />
							<span
								onClick={() => {
									window.open('https://www.facebook.com/pullmansanandres.cl');
								}}
							>
								Facebook
							</span>

						</div>
						<h3 className="sub-main-heading pullman-bold-text font-italic">Ubicación</h3>
						<div
							style={{
								width: '100%',
								height: '300px',
							}}
						>
							<GoogleMapReact
								bootstrapURLKeys={{ key: AppData.MAP_API_KEY }}
								center={{
									lat: parseFloat(-20.273064089035827),
									lng: parseFloat(-70.09177319007587),
								}}
								defaultZoom={18}
							>
								<AnyReactComponent
									lat={parseFloat(-20.273064089035827)}
									lng={parseFloat(-70.09177319007587)}
									img="/assets/bahia/General/pin.png"
								/>
							</GoogleMapReact>
						</div>
					</div>

					<div className="pullman-san-andreas-contact-content-right">
						<h3 className="sub-main-heading pullman-bold-text font-italic">
							Formulario de contacto
						</h3>
						<form>
							<div className="form-group">
								<label htmlFor="">Motivo del mensaje:</label>
								<select type="text">
									<option value>---Seleccione motivo---</option>
									<option value="1">Cotización</option>
									<option value="2">Información</option>
									<option value="3">Reclamo y/o denuncia</option>
									<option value="3">Sugerencia</option>
									<option value="3">Felicitaciones</option>
								</select>
							</div>
							<div className="form-group">
								<label htmlFor="">RUT:</label>
								<input type="text" placeholder="Ingrese su rut" />
							</div>
							<div className="form-group">
								<label htmlFor="">Nombre completo:</label>
								<input type="text" placeholder="Nombres y apellidos" />
							</div>
							<div className="form-group">
								<label htmlFor="">Teléfono / WhatsApp:</label>
								<input type="text" placeholder="+56 9" />
							</div>
							<div className="form-group">
								<label htmlFor="">Email:</label>
								<input type="text" placeholder="ejemplo@pullmansanandres.cl" />
							</div>
							<div className="form-group">
								<label htmlFor="">Ciudad de residencia:</label>
								<input type="text" placeholder="Ciudad/Comuna" />
							</div>
							<div className="form-group">
								<label htmlFor="">Mensaje:</label>
								<textarea type="text" rows="8" />
							</div>
							<div className="form-group d-flex flex-row-reverse">
								<button
									className="  px-4 py-2 font-14px text-white "
									style={{
										backgroundColor:
											operator && operator.color_codes && operator.color_codes.primary_color
												? operator.color_codes.primary_color
												: '',
										border: 'none',
									}}
								>
									ENVIAR
								</button>
							</div>
						</form>
					</div>
				</div>
				<h3 className="sub-main-heading pullman-bold-text font-italic text-center">Sucursales</h3>
				<ThemeSixOfficeSection />
			</div>
		</div>
	);
}
/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		home: state.home,
		common: state.common,
	};
}

export default connect(mapStateToProps)(PullmanSanAndreasContact);



// WEBPACK FOOTER //
// ./src/features/themes/theme6/PullmanSanAndreasPage/PullmanSanAndreasContact.js